// src/redux/slices/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null, // Will store { email, role, tenant_slug, id, etc. }
  notifications: [],
  appContext: localStorage.getItem('app_context') || 'studio', // 'studio' | 'classroom'
  branding: {
    institutionName: '',
    logoUrl: '',
  },
  tenantModules: JSON.parse(localStorage.getItem('tenant_modules') || 'null') || ["examination"],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      
      // If the payload contains app_context (from login), persist it
      if (action.payload?.app_context) {
        state.appContext = action.payload.app_context;
        localStorage.setItem('app_context', action.payload.app_context);
      }
    },
    // NEW: Reducer to switch contexts manually if needed
    setAppContext: (state, action) => {
      state.appContext = action.payload; // 'studio' or 'classroom'
      localStorage.setItem('app_context', action.payload);
    },
    // NEW: Reducer to store University Branding fetched from /public/tenant-branding/
    setBranding: (state, action) => {
      state.branding = {
        institutionName: action.payload.name,
        logoUrl: action.payload.logo,
      };
    },
    addNotification: (state, action) => {
      state.notifications.unshift({
        id: Date.now(),
        ...action.payload,
      });
    },
    clearNotification: (state, action) => {
      state.notifications = state.notifications.filter(n => n.id !== action.payload);
    },
    setTenantModules: (state, action) => {
      state.tenantModules = action.payload;
      localStorage.setItem('tenant_modules', JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.user = null;
      state.notifications = [];
      state.appContext = 'studio';
      state.branding = { institutionName: '', logoUrl: '' };
      state.tenantModules = ["examination"];
      localStorage.clear();
    }
  },
});

export const {
  setUser,
  setAppContext,
  setBranding,
  addNotification,
  clearNotification,
  setTenantModules,
  logout
} = userSlice.actions;

export default userSlice.reducer;